import { Center, Stack, Text } from "@mantine/core"
import EmptyBox from "icons/EmptyBox"
import type { FC, ReactNode } from "react"

interface EmptyStateProps {
  children: ReactNode
  padding?: "sm" | "md" | "lg"
}

const EmptyState: FC<EmptyStateProps> = ({ children, padding = "md" }) => {
  const paddingClasses = {
    sm: "p-2",
    md: "p-24",
    lg: "p-32",
  }

  return (
    <div className={`w-full h-full grid place-items-center ${paddingClasses[padding]}`}>
      <Stack align="center" py="xl">
        <EmptyBox className="w-24" />
        <Text c="gray.7" fw={600} size="xl" ta="center" mt="md">
          {children}
        </Text>
      </Stack>
    </div>
  )
}

export default EmptyState
